// Copyright (c) Microsoft. All rights reserved.

import { IChatMessage } from './ChatMessage';
import { IChatRoom } from './ChatRoom';

export type Conversations = Record<string, IChatRoom>;
export type ContinuationToken = string | null;

export interface ConversationsState {
  conversations: Conversations;
  selectedId: string;
  continuationToken: string | null;
}

export const initialState: ConversationsState = {
  conversations: {},
  selectedId: '',
  continuationToken: null,
};

export interface UpdateConversationPayload {
  id: string;
  messages: IChatMessage[];
}

export interface ConversationTitleChange {
  id: string;
  newTitle: string;
}

export interface ConversationInputChange {
  id: string;
  newInput: string;
}

export interface ConversationSystemDescriptionChange {
  id: string;
  newSystemDescription: string;
}

export interface UpdatePluginStatePayload {
  id: string;
  pluginName: string;
  newState: boolean;
}

export interface ConversationInputChange {
  id: string;
  newInput: string;
}

export interface UpdateBotStatePayload {
  chatRoomId: string;
  isActive: boolean;
}
